<p-messages key="info"></p-messages>
<p-toast key="toast" position="top-left" [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<div class="card" *ngIf='displayState.workingDiv'>
  <div class="card-body">
    <div class="row" >
      <div class="col-md-12 alert alert-info" style="text-align: center"> Processing, please wait. </div>
    </div>
    <div class="row">
      <div class="col-md-2 offset-5">
        <!-- <p-progressSpinner [style]="{width: '100px', height: '100px', margin: '60px'}" strokeWidth="1" fill="#EEEEEE" animationDuration="2.2s"></p-progressSpinner> -->
      </div>
    </div>
  </div>
</div>

<div class="card bg-light" style="margin-top: 5px;">
  <div class="card-body"style="margin-bottom: 3px;">
    <div class="row">
      <div class="col-md-12 bold" style="text-align: center;"><h4>Agenda Summary</h4></div>
    </div>
    <br />
    <div class="row">
      <div class="col-md-3 offset-1">
        <label for="hearingDate" style="padding-right: 10px;"><strong>Hearing Date:</strong></label>
        <select id="hearingDate" style="width: 180px;" title="Select a date" [(ngModel)]="hearingDate" class="form form-input">
          <option value=""></option>
          <!-- <option *ngFor="let opt of schedDateList" [ngValue]="opt.id">{{opt.hearingDate | date:"MM/dd/yyyy"}}</option> -->
          <option *ngFor="let opt of schedDateList" [ngValue]="opt.id">{{opt.hearingDateDesc}}</option>
        </select>
      </div>
      <div class="col-md-3 offset-1">
        <label for="cmbSortType" style="padding-right: 10px;"><strong>Sort By:</strong></label>
        <select id="cmbSortType" style="width: 200px;" [(ngModel)]='mySortBy'>
          <option></option>
          <option *ngFor="let sortProp of sortByList" value="{{sortProp.val}}">{{sortProp.desc}}</option>
        </select>
      </div>
    </div>
    <hr />
    <div class="row">
      <div class="col-md-3 offset-1">
        <button class="btn btn-success" (click)="runAgendaSummary()">Generate Agenda Summary</button>
      </div>
    </div>
  </div>
</div>
